import { useMutation, useQueryClient } from '@tanstack/react-query';
import { buildEventAttendeesPayload } from '../services/extractUserDetails';
import { useEventsScope } from '../contexts/EventsScopeContext';
import { refreshEventDetailQueries } from './refresh-event-detail-queries';

/** POST /admin/events/:eventId/attendees */
export const useAddEventAttendeesMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    ...restOptions,
    meta: { handleErrorLocally: true, ...restOptions.meta },
    mutationFn: async ({ eventId, users }) => {
      if (!api.addEventAttendees) {
        throw new Error('Adding attendees is not available for this account');
      }

      const result = await api.addEventAttendees(eventId, buildEventAttendeesPayload(users));
      if (!result.success) {
        throw new Error(result.message || 'Failed to add attendees');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (variables?.eventId) {
        await refreshEventDetailQueries(queryClient, variables.eventId);
      }
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
  });
};
